import { useState } from 'react';
import Select from 'component/select/select';
import InputText from '../../component/inputText/inputText';
import { useHotelGeneric } from 'context/HotelGenericContext';
import { HotelListModel } from '../../models';
import styles from '../../asset/styles/hotels/hotels.module.scss';
import IconsColor from 'util/iconsColor';
import { getActiveCityOptions } from 'util/cityOptionsUtil';

interface HotelsPopUpProps {
    onFormChange?: (hotelName: string, cityId: number) => void;
    confirmationType?: 'status' | 'delete' | null;
    hotel?: HotelListModel | null;
    hotelNameError?: string;
}

export const HotelsPopUp = ({ onFormChange, confirmationType, hotel, hotelNameError }: HotelsPopUpProps) => {
    const { hotelGenericData } = useHotelGeneric();
    const [hotelName, setHotelName] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    
    // If it's a confirmation dialog, show confirmation content
    if (confirmationType && hotel) {
        if (confirmationType === 'status') {
            return (
                <div className={styles.confirmationContent}>
                    <IconsColor iconName="warningSign" width="80px" height="80px" fillColor="none" strokeColor="#FF0000" />
                    <p className={styles.confirmationText}>
                        Are you sure you want to change the status of <strong>{hotel.hotel_name}</strong> to{' '}
                        <strong>{hotel.flag_active ? 'Inactive' : 'Active'}</strong>?
                    </p>
                </div>
            );
        } else if (confirmationType === 'delete') {
            return (
                <div className={styles.confirmationContent}>
                    <IconsColor iconName="warningSign" width="80px" height="80px" fillColor="none" strokeColor="#FF0000" />
                    <p className={styles.confirmationText}>
                        Are you sure you want to delete <strong>{hotel.hotel_name}</strong>?
                    </p>
                </div>
            );
        }
    }
    
    // Default form for adding new hotel
    const cityOptions = getActiveCityOptions(hotelGenericData.city);
    
    const handleHotelNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setHotelName(value);
        onFormChange?.(value, Number(selectedCity));
    };
    
    const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setSelectedCity(value);
        onFormChange?.(hotelName, Number(value));
    };
    
    return (
        <>
            <InputText 
                label="Hotel Name" 
                value={hotelName} 
                onChange={handleHotelNameChange} 
                placeholder="Enter hotel name" 
                required={true}
                error={hotelNameError}
            />
            <Select 
                label="City" 
                value={selectedCity} 
                onChange={handleCityChange} 
                placeholder="Select City" 
                options={cityOptions} 
                required={true}
                // error={'Please select a city'}
            />
        </>
    )
}
